import { Radio } from '@mui/material';
import styled from 'styled-components';

import { checkboxStyles } from '@/shared/components/ui/shared-styles/shared-styles.styled';
import { TCheckboxStylesProps } from '@/shared/components/ui/shared-styles/shared-styles.types';

export const StyledRadio = styled(Radio)<TCheckboxStylesProps>`
  && {
    ${checkboxStyles};
  }
`;
